<template>

  <v-container>
    <v-form ref="form" v-model="valid">
      <v-subheader>We do not need to know much just Nickname, Email and a Password.</v-subheader>
      <v-text-field
        v-model="name"
        :rules="nameRules"
        label="Nickname"
        required>
      </v-text-field>

      <v-text-field
        v-model="email"
        :rules="emailRules"
        label="E-mail"
        required
      >
      </v-text-field>

      <v-text-field
        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
        :type="showPassword ? 'text' : 'password'"
        label="Password"
        v-model="password"
        :rules="passwordRules"
        class="input-group--focused"
        @click:append="showPassword = !showPassword">
      </v-text-field>

      <v-btn color="success" class="mr-4" @click="createAccount" v-if="newAccount">
        Create Account
      </v-btn>

      <!-- <v-row>
        <v-col cols="12" sm="12" md="12">
        </v-col>
      </v-row> -->
    </v-form>
    <v-snackbar v-model="alertShow" top color="red">
      {{alertMessage}}
      <v-btn color="white" outlined x-small @click.native="alertShow = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>

</template>
<script>

export default {
  name: 'Account',
  props: {
    newAccount: Boolean,
  },
  data: () => ({
    valid: true,
    password: '',
    showPassword: false,
    name: '',
    nameRules: [
      (v) => !!v || 'Nickname is required',
      (v) => (v && v.length > 3) || 'Nickname must be more than 3 characters',
    ],
    email: '',
    emailRules: [
      (v) => !!v || 'E-mail is required',
      (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],
    passwordRules: [
      (v) => !!v || 'Password is required',
      (v) => (v && v.length > 6) || 'Password must be more than 6 characters',
    ],
    alertShow: false,
    alertMessage: '',
  }),
  components: {
  },
  mounted() {
  },
  methods: {
    createAccount() {
      const data = {
        name: this.name,
        email: this.email,
        password: this.password,
      };

      this.$webConn.request('app2_create_account', data).then((result) => {
        this.$root.afterLogin(result);
      }).catch((error) => {
        console.log('error');
        this.alertMessage = error.Message;
        this.alertShow = true;
      });
    },
  },
};

</script>
